/**
 * Memoize a function with only 1 parameter using a WeakMap
 * @example
 *   const myExpansiveFunction = (data: Data): boolean => {
 *     // intense machine learning algorithm here
 *   }
 *   const memoizedExpansiveFunction = withMemoSimple(myExpansiveFunction)
 **/
export const withMemoSimple = (fun) => {
    const wm = new WeakMap();
    return (p) => {
        if (wm.has(p))
            return wm.get(p);
        const r = fun(p);
        wm.set(p, r);
        return r;
    };
};
/** Memoize a function with 2 paramaters using a WeakMap */
export const withMemoDouble = (fun) => {
    const p1wm = new WeakMap();
    return (p1, p2) => {
        let p2wm;
        if (p1wm.has(p1)) {
            p2wm = p1wm.get(p1);
        }
        else {
            p2wm = new WeakMap();
            p1wm.set(p1, p2wm);
        }
        if (p2wm.has(p2))
            return p2wm.get(p2);
        const r = fun(p1, p2);
        p2wm.set(p2, r);
        return r;
    };
};
//# sourceMappingURL=memo.js.map